import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Slide } from '@interfaces';

@Component({
  selector: 'app-info-block-start-page',
  templateUrl: './info-block-start-page.component.html',
  styleUrls: ['./info-block-start-page.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoBlockStartPageComponent {
  @Input() public slide: Slide;
  @Input() public type: string;
  @Input() public ws: string;
  @Input() public hs: string;

}


